<template>
  <Card class="fdv">
    <template #header>
      <div class="row between g-1 grow-1">
        <div class="row g-1">
          <h2>{{ $t('managementOperationMaintenance') }}</h2>
          <HelperPopover template="management-operation-maintenance-helper" />
        </div>
        <Actions
          class="text--small"
          placement="residentialAccount:documents"
          :query="{ residentialAccount: $route.params.id }"
        />
      </div>
    </template>
    <template #default>
      <Directory v-model="value.documents" data-widget="directory" />
    </template>
    <template #footer>
      <CheckboxComponent
        v-model="value.metadata.settings.documentUploadConfirm"
        :label="$t('fdvControlLabel')"
        :sublabel="$t('fdvControlSublabel')"
      />
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import Directory from '@kvass/directories'
import HelperPopover from '@/components/HelperPopover/Component'
import { CheckboxComponent } from 'vue-elder-checkbox'
import Actions from '@/components/Actions'

export default {
  props: {
    value: Object,
  },
  components: {
    Directory,
    Card,
    CheckboxComponent,
    HelperPopover,
    Actions,
  },
}
</script>

<style lang="scss">
.fdv {
  .card__header {
    min-height: initial;
    flex-direction: row;
    justify-content: flex-start;

    h2 {
      margin: 0;
    }
  }
}
</style>
